// extracted by mini-css-extract-plugin
export default {"picture":"styles_picture__fwfMx","provider":"styles_provider__jcDLC","input_old_stock":"styles_input_old_stock__eCtxK"};